<template>
	<div>
		<div class="modal fade" id="mdconsultarpedidos">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-search"></i> Consulta de pedidos para importação</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edidpedidopesq">Nr. Pedido:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'######'" class="form-control form-control-sm" v-model="pidpedido" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Cliente:</span>
								<select id="cbclientepesq" data-placeholder="Selecione um cliente" v-model="pidcliente" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Vendedor:</span>
								<select id="cbvendedorpesq" data-placeholder="Selecione um vendedor" v-model="pidvendedor" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtipopesq">Tipo:</label>
                                <select name="cbtipopesq" class="form-control form-control-sm" id="cbtipopesq" v-model="ptipo" @change="mtdlimpar_listagem()">
                                    <option value="0">Pedidos</option>
                                    <option value="1">Orçamentos</option>
                                    <option value="2">Ordens de serviço</option>
                                    <option value="4">Todos</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edidentificadorospesq">Identificador:</label>
								<input type="text" class="form-control form-control-sm" id="edidentificadorospesq" v-model="pidentificador" data-bv-group=".group" maxlength="20">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="ednrserieospesq">Número de série:</label>
								<input type="text" class="form-control form-control-sm" id="ednrserieospesq" v-model="pnrserie" data-bv-group=".group" maxlength="20">
							</div>														
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>														
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div id="dvlistagempedidos" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstpedidos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
										<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdretornoconsulta(item.row.id)" style="width: 35px;">
											<i class="fa fa-hand-o-up"></i>
										</button>
                                    </template>									
                                    <template slot="id_f" slot-scope="item">
										{{ mtdformatarzeros(item.row.id, 8) }} 
                                        <i v-if="parseInt(item.row.liberarpdv) === 1" class="fa fa-unlock" style="color: #5A956A;" title="Liberado para o PDV"></i>
										<i v-else class="fa fa-lock" style="color: #EEA435;" title="Bloqueado para o PDV"></i>
                                        <i v-if="parseInt(item.row.entregaexterna) === 1" class="fa fa-truck" title="Entrega externa" style="color: #0acf97; margin-left: 3px; transform: scale(-1, 1);"></i>
                                    </template>

                                    <template slot="slot_tipo" slot-scope="item">
                                        <template v-if="parseInt(item.row.tipo) === 0">
											<span class="badge badge-primary badge-pill" style="background-color: #6BA2D0;">PEDIDO</span>
                                        </template>
                                        <template v-else-if="parseInt(item.row.tipo) === 1">
											<span class="badge badge-primary badge-pill" style="background-color: #EEA435;">ORÇAMENTO</span>
                                        </template>
                                        <template v-else>
											<span class="badge badge-primary badge-pill" style="background-color: #A42F11;">O. S.</span>
                                        </template>										
                                    </template>
                                    <template slot="slot_dtemissao" slot-scope="item">
                                        {{ item.row.dtemissao }}
                                    </template>																		
									<template slot="slot_totalgeral" slot-scope="item">
										<span style="color: #6c757d; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.totalgeral), 2) }}</span>
									</template>																						
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-4">
                                <v-pagination style="padding: 5px 10px 5px 10px;" class="border rounded"
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>            
                            </div>    
                            <div class="col-md-8">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstpedidos.length}}</span>
                                    </li>
                                </ul>
                            </div>                            
						</div>
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>        
	</div>
</template>
<script>
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
	import util from '../utilitarios/util.js'
	export default {
        name : "cmpconsultarpedidos",
        props:[
            'idfilial'
        ],
        components:{
            VueBootstrap4Table,
            vPagination
        },			
		data: function () {
			return {
				lstpedidos   		: [],
				pidpedido    		: '',
				pidcliente	 		: null,
				pidvendedor  		: null,
				ptipo				: 4,
				pidentificador		: '',
				pnrserie			: '',
				pfiltroperiodo      : 1,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),				
                pqtdregistros		: 10,
                pqtd_paginas 		: 1,
                pagina_atual 		: 1,
                pqtd_total_registros: 0,

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },                                
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
				},
                columns: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes_ped",
						sort: false						
                    },
                    {
                        label: "Nr. Pedido",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
						row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "Tipo",
                        name: "tipo",
                        sort: true,
                        slot_name: "slot_tipo",
                        row_classes: "def-col-tipo",
					},																			
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
						sort: true,
						slot_name: "slot_dtemissao",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Filial",
                        name: "fantasia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vendedor",
                        name: "nomevendedor",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "Plano",
                        name: "descplano",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Identificador",
                        name: "identificador",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Nr. Série",
                        name: "nrserie",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },					
                    {
                        label: "Valor",
                        name: "totalgeral",
                        sort: true,
                        slot_name: "slot_totalgeral",
						column_classes: "def-col-totalgeral",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					}               
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
				}    
            }
        },
		methods: {
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},            
			mtdiniciar_def(){
				let vself = this;
				$('#mdconsultarpedidos').on('show.bs.modal', function (e) {
                    vself.lstpedidos   		    = [];
                    vself.pidpedido    		    = '';
                    vself.pidcliente	 	    = null;
                    vself.pidvendedor  		    = null;
                    vself.ptipo				    = 4;
                    vself.pidentificador	    = '';
                    vself.pnrserie			    = '';
                    vself.pfiltroperiodo        = 1;
                    vself.pdtini       		    = util.DataAtual(true);
                    vself.pdtfim       		    = util.DataAtual(true);				
                    vself.pqtdregistros		    = 10;
                    vself.pqtd_paginas 		    = 1;
                    vself.pagina_atual 		    = 1;
                    vself.pqtd_total_registros  = 0;
				});				
				$('#mdconsultarpedidos').on('shown.bs.modal', function (e) {
					$('#edidpedidopesq').focus();
				});
				$('#mdconsultarpedidos').on('hidden.bs.modal', function (e) {
					vself.mtdfecharconsulta();
                });
                
				$("#cbclientepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidcliente = $("#cbclientepesq").val();
                    vself.mtdlimpar_listagem();
				});
				$("#cbvendedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidvendedor = $("#cbvendedorpesq").val();
                    vself.mtdlimpar_listagem();                    
				});                
			},            
			mtdretornoconsulta(idpedidoret){
				let payload = {
					idpedido    : idpedidoret			
				};
				this.$store.commit('PEDIDO_RETORNO_CHANGE',payload);					
				this.mtdfecharconsulta();
			},            
			mtdfecharconsulta(){
				let payload = {
					abrirtela    : false			
				};
				this.$store.commit('CONSULTA_PEDIDO_CHANGE',payload);								
            },
            mtdlimpar_listagem() {
                this.lstpedidos = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },            
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (this.pidpedido !== ''){
                    rfiltro = ' and p.id='+this.pidpedido;
                }
                
                //Filtra somente os em aberto
                rfiltro = rfiltro + ' and p.stpedido=0 and p.liberarpdv=1';

				if (this.idfilial !== ''){
					rfiltro = rfiltro + ' and p.idfilial='+this.idfilial;
				}
				if (this.pidcliente !== null){
					rfiltro = rfiltro + ' and p.idcliente='+this.pidcliente;
				}
				if (this.pidvendedor !== null){
					rfiltro = rfiltro + ' and p.idvendedor='+this.pidvendedor;
				}
				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and p.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
				}				
				if (parseInt(this.ptipo) < 4){
					rfiltro = rfiltro + ' and p.tipo='+this.ptipo;
				}
				if (this.pidentificador !== ''){
					rfiltro = rfiltro + ' and upper(p.identificador) like upper("'+this.pidentificador+'%")';
				}
				if (this.pnrserie !== ''){
					rfiltro = rfiltro + ' and upper(p.nrserie) like upper ("'+this.pnrserie+'%")';
				}				
                return rfiltro;
            },
            mtdexecutapesquisa(){
				let vself           = this;				
				let filtro          = vself.mtdfiltropesquisa();
				this.pagina_atual   = 1;
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor  : 'qtdregistros'},
					{parametro: 'filtro',       valor  : filtro}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
					let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
					vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
					vself.mtdcarregapedidos(1);
				}).catch(function (response) {
					alert('Erro ao consultar registros');
				});				
            },                                    
            mtdcarregapedidos(ipagina){
                if (util.verificasessao(this)){
                    var vself       = this;
                    let loader      = this.$loading.show();
                    let filtro      = vself.mtdfiltropesquisa();
                    let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : vself.pqtdregistros},
                        {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                    retorno.then(function (response) {
						vself.lstpedidos = response.data.pedidos;
						loader.hide();											
                    }).catch(function (response) {
                        vself.lstpedidos = [];
                        loader.hide();
                    });
                }
            }
        },
        mounted: function () { 
            this.mtdiniciar_def();      
        },
        computed: {
            abrirtela(){
                return this.$store.state.consultapedidos.abrirtela;                
            },
			selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
			}            						
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregapedidos(val);
			},            
			abrirtela(val){
				if (val){
					$('#mdconsultarpedidos').modal('show');
				}else{					
					$('#mdconsultarpedidos').modal('hide');
				}
			},
            pagina_atualcp(val){
                this.mtdcarregapedidos(val);
            }			
        }            
    }
</script>
<style>
</style>    